<template>
  <div class="yxyj_wrap">
    <div class="head_box">
      益学堂——<br />具有专业能力和职业精神的投资者教育平台
    </div>

    <div class="yxyj_container">
      <!-- 数据加载完成后的内容 -->
      <div class="video_box" v-if="dataList.length > 0">
        <div
          class="video_list"
          v-for="(item, index) in dataList"
          :key="index"
          @mouseenter="handleMouseEnter(index)"
          @mouseleave="handleMouseLeave(index)"
        >
          <div class="video_container">
            <!-- 视频占位图 - 只在视频未加载时显示 -->
            <div class="video_placeholder" v-if="!videoLoaded[index]">
              <img
                src="@/assets/about_us/focus/yxyj/video_placeholder.png"
                alt="视频加载中"
              />
            </div>

            <!-- 视频元素 - 初始不设置src，悬停时动态加载 -->
            <video
              width="100%"
              :ref="(el) => (videoRefs[index] = el)"
              muted
              preload="none"
              controls
              @loadstart="onVideoLoadStart(index)"
              @loadeddata="onVideoLoaded(index)"
              @canplay="onVideoCanPlay(index)"
              @error="onVideoError(index)"
              :style="{ display: videoLoaded[index] ? 'block' : 'none' }"
            ></video>

            <!-- 封面图层 - 数据加载完成就显示 -->
            <div
              class="poster_overlay"
              :class="{
                hidden: currentPlayingIndex === index && videoLoaded[index],
              }"
              :style="{
                backgroundImage: `url(${COMMON.removeHttpProtocol(
                  item.cover
                )})`,
              }"
            >
              <div class="play_icon">▶</div>
            </div>
          </div>

          <!-- 标题区域 -->
          <div class="title_container">
            <div class="title" :title="item.title">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>

      <div class="text_box">
        <div class="text">
          中国拥有1.3亿股民，他们为国家经济的发展做出了巨大贡献。然而，许多股民对证券知识、法规和历史了解不足，风险意识薄弱，常常因盲目入市而遭受损失。益学堂致力于为股民提供全面的教育服务，帮助他们提高投资素养，减少不必要的风险。
        </div>

        <div class="text">
          在益学堂，学员不仅可以学习证券知识，还能通过平台享受新闻信息、生活资讯，金融产品等多元化服务。益学堂致力于打造一个以情感为纽带、以证券培训为核心，充满互动与关爱的社区。此外，益学堂还与省级电视台、网络电视台等媒体展开合作，不断拓展更多深度合作机会。
        </div>

        <div class="text">
          追求卓越是我们的使命，也是我们不断前进的动力。客户的认可和正面评价是我们存在的价值，也是推动我们不断进步的重要力量。
        </div>

        <div class="text">
          "不忘初心，方得始终。"展望未来，我们充满希望"一位哲人曾说，如果不能成为别人的礼物，就不要走近别人的生活。我们希望益学堂能成为广大学员生命中的宝贵礼物，共同成长，共创辉煌。"
        </div>

        <div class="info">
          视频均以获得用户授权，不做任何投资参考，作为广告视频使用
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: [],
      videoRefs: [], // 视频引用数组
      currentPlayingIndex: -1, // 当前播放的视频索引
      videoLoaded: [], // 记录视频是否已加载
      videoSrcSet: [], // 记录视频src是否已设置
      videoLoading: [], // 记录视频是否正在加载
      lastPlayedIndex: -1, // 记录上次播放的视频索引
    };
  },
  created() {
    this.getDataList(); // 获取 研学list
  },
  mounted() {},
  beforeUnmount() {
    // 组件卸载前暂停所有视频
    this.videoRefs.forEach((video) => {
      if (video) {
        video.pause();
      }
    });
  },
  methods: {
    // 鼠标移入事件
    handleMouseEnter(index) {
      // console.log(`鼠标进入视频 ${index}`);
      this.currentPlayingIndex = index;

      // 如果切换到不同的视频，重置上一个视频
      if (this.lastPlayedIndex !== -1 && this.lastPlayedIndex !== index) {
        this.resetVideo(this.lastPlayedIndex);
      }

      // 如果视频还没有设置src，先设置src并加载
      if (!this.videoSrcSet[index]) {
        this.loadVideoSource(index);
        return;
      }

      // 如果视频已经加载完成，直接播放
      if (this.videoLoaded[index]) {
        this.playVideo(index);
      }

      this.lastPlayedIndex = index;
    },

    // 鼠标移出事件
    handleMouseLeave(index) {
      // console.log(`鼠标离开视频 ${index}`);
      const video = this.videoRefs[index];
      if (video) {
        video.pause();
      }
      this.currentPlayingIndex = -1;
    },

    // 重置视频到开始
    resetVideo(index) {
      const video = this.videoRefs[index];
      if (video) {
        video.currentTime = 0;
      }
    },

    // 加载视频源
    loadVideoSource(index) {
      const video = this.videoRefs[index];
      if (video && !this.videoSrcSet[index]) {
        // console.log(`开始加载视频 ${index}`);
        this.videoLoading[index] = true;

        const videoUrl = this.COMMON.removeHttpProtocol(
          this.dataList[index].video
        );
        // console.log(`设置视频源: ${videoUrl}`);

        video.src = videoUrl;
        this.videoSrcSet[index] = true;

        // 手动触发加载
        video.load();
      }
    },

    // 视频开始加载
    onVideoLoadStart(index) {
      // console.log(`视频 ${index} 开始加载`);
      this.videoLoading[index] = true;
    },

    // 视频数据加载完成
    onVideoLoaded(index) {
      // console.log(`视频 ${index} 数据加载完成`);
    },

    // 视频可以播放
    onVideoCanPlay(index) {
      // console.log(`视频 ${index} 可以播放`);
      this.videoLoaded[index] = true;
      this.videoLoading[index] = false;

      // 如果鼠标还在当前视频上，开始播放
      if (this.currentPlayingIndex === index) {
        this.playVideo(index);
      }
    },

    // 视频加载错误
    onVideoError(index) {
      // console.error(`视频 ${index} 加载失败`);
      this.videoLoading[index] = false;
      // 即使加载失败，也标记为已加载以避免无限等待
      this.videoLoaded[index] = true;
    },

    // 播放视频
    playVideo(index) {
      const video = this.videoRefs[index];
      if (video && this.videoLoaded[index]) {
        // console.log(`开始播放视频 ${index}`);
        video.play().catch((error) => {
          console.log(`视频 ${index} 播放失败:`, error);
        });
      }
    },

    // 获取 研学list
    getDataList() {
      this.API.CLOUDGet("cms/api/case-video/list", {})
        .then((res) => {
          let datas = res.data.data;
          this.dataList = datas;

          // 初始化视频加载状态数组
          this.videoLoaded = new Array(datas.length).fill(false);
          this.videoSrcSet = new Array(datas.length).fill(false);
          this.videoLoading = new Array(datas.length).fill(false);
        })
        .catch((error) => {
          console.error("获取视频列表失败:", error);
          this.dataList = [];
        });
    },
  },
};
</script>

<style lang="less" scoped>
.yxyj_wrap {
  min-height: calc(100vh - 109px);
  background: url("@/assets/about_us/focus/shgsyx/bg.png") no-repeat #000;
  background-size: 100%;
  color: #fff;
  padding: 56px 4% 112px;
  box-sizing: border-box;

  .head_box {
    font-size: 30px;
    line-height: 48px;
  }

  .yxyj_container {
    .video_box {
      display: flex;
      flex-wrap: wrap;

      .video_list {
        width: calc(92% / 3);
        margin-top: 56px;
        margin-right: 4%;
        cursor: pointer;
        transition: transform 0.3s ease;

        &:nth-child(3n) {
          margin-right: 0;
        }

        &:hover {
          transform: translateY(-5px);
        }

        .video_container {
          position: relative;
          width: 100%;
          border-radius: 8px;
          overflow: hidden;
          aspect-ratio: 16/9;
          background: #f0f0f0;

          .video_placeholder {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #2a2a2a;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          video {
            width: 100%;
            height: 100%;
            display: block;
            background: #000;
            object-fit: cover;
          }

          .poster_overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: opacity 0.3s ease;
            cursor: pointer;

            &.hidden {
              opacity: 0;
              pointer-events: none;
            }

            .play_icon {
              width: 30px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              background: #fff;
              border-radius: 50%;
              font-size: 14px;
              color: #000;
              padding-left: 4px;
              box-sizing: border-box;
              transition: all 0.3s ease;
            }
          }

          &:hover .poster_overlay:not(.hidden) .play_icon {
            transform: scale(1.1);
            background: rgba(255, 255, 255, 0.9);
          }
        }

        .title_container {
          position: relative;
          margin-top: 12px;
          min-height: 20px;

          .title {
            font-size: 16px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
          }
        }
      }
    }

    .text_box {
      margin-top: 56px;

      .text {
        font-size: 14px;
        text-align: justify;
        margin-top: 28px;
        line-height: 24px;
      }

      .info {
        font-size: 12px;
        margin-top: 56px;
        color: #999;
        text-align: center;
      }
    }
  }
}

@media (min-width: 1921px) {
  .yxyj_wrap {
    padding: 112px 4%;

    .yxyj_container {
      margin-top: 112px;
    }
  }
}
</style>